import { styled } from "@vitality-ds/system";
import BaseFormFieldLabelStyles from "./styles/BaseLabel.styles";
import BaseLabelRequiredStyles from "./styles/BaseLabelRequired.styles";
export var BaseLabel = styled("label", BaseFormFieldLabelStyles);
export var BaseLabelRequired = styled("span", BaseLabelRequiredStyles);